import { performRequest, apiEndPoints, methodType } from "./_apiConfig";
import { commonErrorHandler } from "./voterService";

const cleanListParams = (data = {}) =>
  Object.entries(data).reduce((params, [key, value]) => {
    if (key === "currentPage") return params;
    if (value === "" || value === null || value === undefined) return params;
    return { ...params, [key]: value };
  }, {});

export const getBlaBleList = (data = {}) => {
  return performRequest(methodType.GET, apiEndPoints.blaBle, cleanListParams(data), true)
    .then((response) => {
      console.log("12",response);
      
      if (!response.success) {
        commonErrorHandler(response);
      }
      return response;
    })
    .catch((error) => error);
};

export const getBlaBleDetails = (data = {}) => {
  return performRequest(
    methodType.GET,
    `${apiEndPoints.blaBle}/${data?.id}`,
    data,
    true
  )
    .then((response) => {
      if (!response.success) {
        commonErrorHandler(response);
      }
      return response;
    })
    .catch((error) => error);
};

export const addBlaBle = (data = {}) => {
  return performRequest(methodType.POST, apiEndPoints.blaBle, data, true, true)
    .then((response) => {
      if (!response.success) {
        commonErrorHandler(response);
      }
      return response;
    })
    .catch((error) => error);
};

export const updateBlaBle = (data = {}) => {
  return performRequest(
    methodType.PATCH,
    `${apiEndPoints.blaBle}/${data?.id}`,
    data?.formData,
    true,
    true
  )
    .then((response) => {
      if (!response.success) {
        commonErrorHandler(response);
      }
      return response;
    })
    .catch((error) => error);
};

export const deleteBlaBle = (data = {}) => {
  return performRequest(
    methodType.DELETE,
    `${apiEndPoints.blaBle}/${data?.id}`,
    data,
    true
  )
    .then((response) => {
      if (!response.success) {
        commonErrorHandler(response);
      }
      return response;
    })
    .catch((error) => error);
};
